import React, { useCallback } from 'react';
import { PanelSplitter } from '@atlaskit/navigation-system';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { RightPanel } from '@atlassian/jira-navigation-system/src/index.tsx';
import { useCurrentPreviewPanel } from '@atlassian/preview-panels-api';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';

import { messages } from './messages.tsx';

export const PreviewPanel = () => {
	const panel = useCurrentPreviewPanel();
	const { formatMessage } = useIntl();

	const onResizeEnd = useCallback(
		({ finalWidth }: { finalWidth: number }) => {
			panel?.setWidth?.(finalWidth);
		},
		[panel],
	);

	if (panel === null) {
		return null;
	}

	const { content: PanelContent, width } = panel;

	return (
		<RightPanel width={width} testId="page-container-v2.common.ui.preview-panel">
			<JSErrorBoundary
				fallback="unmount"
				id="preview-panel-route-components"
				packageName="page-container"
			>
				<PanelContent />
				<PanelSplitter
					label={formatMessage(messages.previewPanelSplitterLabel)}
					onResizeEnd={onResizeEnd}
					testId="page-container-v2.common.ui.preview-panel.panel-splitter"
				/>
			</JSErrorBoundary>
		</RightPanel>
	);
};
